//判断机型
let u = navigator.userAgent;

function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  let WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

//自定义JS注册事件监听 connectWebViewJavascriptBridge 方法名可改
function connectWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      () => {
        // 增加存在性检查，防止 bridge 未注入时报错
        if (window.WebViewJavascriptBridge) {
          callback(window.WebViewJavascriptBridge);
        }
      },
      false
    );
  }
}

//注册回调函数，第一次连接时调用 初始化函数 connectWebViewJavascriptBridge和上面一致
connectWebViewJavascriptBridge(function (jsbridge) {
  //初始化 必须有 Android 通过 JSBridge 调用 默认JS bridge.init bridgeWebView.send调用
  jsbridge.init(function (message, callback) {
    callback({ "Javascript Responds": "Android调用JS初始化方法!" });
  });
});

export default {
  registerHandler: function (name, fun) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
      setupWebViewJavascriptBridge(function (jsbridge) {
        jsbridge.registerHandler(name, function (data, responseCallback) {
          if (responseCallback) {
            responseCallback(fun && fun(data));
          } else {
            fun && fun(data);
          }
        });
      });
    } else {
      connectWebViewJavascriptBridge(function (jsbridge) {
        //Android调用js方法：functionInJs方法名称需要保持一致 ，并返回给Android通知
        jsbridge.registerHandler(name, function (data, responseCallback) {
          if (responseCallback) {
            responseCallback(fun && fun(data));
          } else {
            fun && fun(data);
          }
        });
      });
    }
  },
  callHandler: function (name, data, fun) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
      setupWebViewJavascriptBridge(function (jsbridge) {
        jsbridge.callHandler(name, data, function (data) {
          fun(data);
        });
      });
    } else {
      connectWebViewJavascriptBridge(function (jsbridge) {
        //JS调用Android方法：接收Android传递过来的数据，并做处理
        jsbridge.callHandler(name, data, function (data) {
          fun(data);
        });
      });
    }
  },
};
